module.exports = __webpack_public_path__ + "static/media/Fhall.bbffcc26.jpg";